export class SdkGameEvent {}
